import axios, { AxiosResponse } from "axios";
import { CalendarData } from "../interfaces/EspolAds/CalendarData";
import { UnidadAds } from "../interfaces/EspolAds/Unidad";
const SERVICE : string = process.env.REACT_APP_ESPOLADS || ''; 
const APIRECEPTOR : string = 'catalog/Receptor/';
const APIUNIDAD : string ='catalog/unidad';
const APIAREA : string ='catalog/area';
//calendar/142

export default class AdsService{

    async GetCalendarService(idunidad:number): Promise<Array<CalendarData>> {
        const response1:AxiosResponse<Array<CalendarData>> = await axios.get(SERVICE+APIRECEPTOR+'calendar/'+idunidad,
        {
            headers: {
              //Authorization: `Bearer ${token}`
            }
        });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetUnidadesEspolAds(): Promise<Array<UnidadAds>> {
        const response1:AxiosResponse<Array<UnidadAds>> = await axios.get(SERVICE+APIUNIDAD,
        {
            headers: {
              //Authorization: `Bearer ${token}`
            }
        });
        //console.log(response1.data);        
        return response1.data;
    }
}